import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { PAYMENT_LEVELS } from '#/utils/constants/general/paymentLevels';

export function paymentFacet(i18n: I18nFn) {
  return {
    id: 'paymentFacet',
    name: 'payment',
    get title() {
      return i18n('Compensation');
    },
    type: 'array',
    options: Object.keys(PAYMENT_LEVELS(i18n)),
    optionTitles: PAYMENT_LEVELS(i18n),
  } as const satisfies SearchFacetData;
}
